import { MenuItem, Select } from "@mui/material"
import { DEFAULT_YES_NO_OPTIONS, NOT_SET_VALUE } from "../../../utils/constants/userSettingsConstants";

const YesNoSelect = ({value, onChange, fullWidth, optionNames = DEFAULT_YES_NO_OPTIONS, notSetOption}) => {
    return (
        <Select fullWidth={fullWidth} value={value} onChange={onChange} displayEmpty={notSetOption}>
            {
                notSetOption &&
                <MenuItem key={-1} value={NOT_SET_VALUE}>{optionNames[NOT_SET_VALUE].name}</MenuItem>
            }
            <MenuItem key={0} value={true}>{optionNames[true].name}</MenuItem>
            <MenuItem key={1} value={false}>{optionNames[false].name}</MenuItem>
        </Select>
    )
}

export default YesNoSelect;